import React, { ReactNode, useState } from 'react'
import { Dropdown, Icon, Menu } from 'antd'

import images from 'src/config/images'
import i18n from 'src/config/i18n'

import { Flag } from './styles'
import { MenuItem } from '../Ant'

interface Props {
  children?: ReactNode
  showTheChosen?: boolean
}

export function changeLanguage(lng: string = 'en') {
  const language = lng.toLowerCase()
  i18n.changeLanguage(language)
  localStorage.setItem('language', language)
}

function defaultIcon(extend?: boolean) {
  if (!extend) {
    return <Icon type="global" />
  }

  const { language } = i18n

  let src = null
  let displayLanguage = ''

  switch (language.toUpperCase()) {
    case 'PT':
    case 'PT-BR':
    case 'PT_BR':
      src = images.flags.brazil
      displayLanguage = 'Português'
      break
    case 'EN':
    case 'EN-EN':
    case 'EN_EN':
      src = images.flags.unitedStates
      displayLanguage = 'English'
      break
    case 'ES':
    case 'ES-ES':
    case 'ES_ES':
      src = images.flags.spain
      displayLanguage = 'Español'
      break
    default:
      return <Icon type="global" />
  }

  return (
    <span>
      <Flag src={src} />
      <span>{displayLanguage}</span>
    </span>
  )
}

export default function LanguagePicker({
  showTheChosen = false,
  children
}: Props) {
  const { language } = i18n
  const [lng, setLng] = useState<string>(language)

  return (
    <Dropdown
      overlay={
        <Menu
          onClick={async ({ key }) => {
            changeLanguage(key)
            setLng(key)
          }}
          selectedKeys={[lng]}
        >
          <MenuItem
            key="en"
            aria-label="English"
            icon={<Flag src={images.flags.unitedStates} />}
          >
            English
          </MenuItem>
          <MenuItem
            key="pt"
            aria-label="Português"
            icon={<Flag src={images.flags.brazil} />}
          >
            Português
          </MenuItem>
          <MenuItem
            key="es"
            aria-label="Español"
            icon={<Flag src={images.flags.spain} />}
          >
            Español
          </MenuItem>
        </Menu>
      }
      trigger={['hover']}
      placement="topRight"
    >
      {children || defaultIcon(showTheChosen)}
    </Dropdown>
  )
}
